webpackJsonp([1],{

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0e5O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Door = undefined;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Pricelist = __webpack_require__("oyMF");

var _Configuration = __webpack_require__("jbNl");

var _InvalidConfigurationError = __webpack_require__("LOsN");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Door = function () {
    function Door(partition) {
        (0, _classCallCheck3.default)(this, Door);

        /**
         * @type {Partition}
         * @private
         */
        this._partition = partition;

        /**
         * @type {string}
         * @private
         */
        this._type = this.noDoor;

        /**
         * @type {string}
         * @private
         */
        this._ironmongery = this.ironmongeryDHandle;

        /**
         * @type {object}
         */
        this._configuration = _Configuration.Configuration.get();

        /**
         * @type {object}
         */
        this._pricelist = _Pricelist.Pricelist.get();
    }

    /**
     * @param {string} doorType
     */


    (0, _createClass3.default)(Door, [{
        key: '_checkDoorType',


        /**
         * @param {string} doorType
         * @returns {boolean}
         * @private
         */
        value: function _checkDoorType(doorType) {
            var configuration = this._configuration.singleGlazed.doors;

            if (doorType === this.noDoor && this._partition.numberOfSides === 4) {
                return false;
            }

            if (this._partition.isDoubleGlazed) {
                configuration = this._configuration.doubleGlazed.doors;
            }

            return Boolean(configuration.includes(doorType));
        }
    }, {
        key: 'type',
        set: function set(doorType) {

            if (this._partition.hasValidDimensions === false) {
                throw new _InvalidConfigurationError.InvalidConfigurationError('Dimensions are invalid');
            }

            if (this._partition.glassThickness === undefined) {
                throw new _InvalidConfigurationError.InvalidConfigurationError('Glass thickness undefined');
            }

            if (this._checkDoorType(doorType) === false) {
                throw new _InvalidConfigurationError.InvalidConfigurationError();
            }

            this._type = doorType;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'totalInPence',
        get: function get() {
            // If the door is configured incorrectly return 0
            if (this._checkDoorType(this._type) === false) {
                return 0;
            }

            var doorPrice = this._pricelist.doors[this._type];
            var ironmongeryPrice = this._pricelist.ironmongery[this._ironmongery];

            // No door means no handle
            if (this._type === this.noDoor) {
                ironmongeryPrice = 0;
            }

            var pricePerDoor = doorPrice + ironmongeryPrice;
            var totalPrice = pricePerDoor;

            if (this._partition.type === this._partition.tShapeType) {
                totalPrice = pricePerDoor * 2;
            }

            return totalPrice;
        }

        /**
         * @param {string} ironmongery
         */

    }, {
        key: 'ironmongery',
        set: function set(ironmongery) {
            this._ironmongery = ironmongery;
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'noDoor',
        get: function get() {
            return 'noDoor';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'singleGlazedDoorFrameless',
        get: function get() {
            return 'singleGlazedDoorFrameless';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'singleGlazedDoorIncFrame',
        get: function get() {
            return 'singleGlazedDoorIncFrame';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'singleGlazedDoorIncSingleGlazedFrame',
        get: function get() {
            return 'singleGlazedDoorIncSingleGlazedFrame';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'singleGlazedDoorIncDoubleGlazedFrame',
        get: function get() {
            return 'singleGlazedDoorIncDoubleGlazedFrame';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'doubleGlazedDoor',
        get: function get() {
            return 'doubleGlazedDoor';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'ironmongeryDHandle',
        get: function get() {
            return 'dHandle';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'ironmongeryManet',
        get: function get() {
            return 'manet';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'ironmongeryLeverLock',
        get: function get() {
            return 'leverLock';
        }
    }]);
    return Door;
}();

exports.Door = Door;

/***/ }),

/***/ "FOBA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('configurator')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "LOsN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidConfigurationError = undefined;

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _construct = __webpack_require__("pQ2V");

var _construct2 = _interopRequireDefault(_construct);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = (0, _construct2.default)(cls, (0, _from2.default)(arguments));
    (0, _setPrototypeOf2.default)(instance, (0, _getPrototypeOf2.default)(this));
    return instance;
  }

  ExtendableBuiltin.prototype = (0, _create2.default)(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_setPrototypeOf2.default) {
    (0, _setPrototypeOf2.default)(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var InvalidConfigurationError = function (_extendableBuiltin2) {
  (0, _inherits3.default)(InvalidConfigurationError, _extendableBuiltin2);

  function InvalidConfigurationError() {
    (0, _classCallCheck3.default)(this, InvalidConfigurationError);
    return (0, _possibleConstructorReturn3.default)(this, (InvalidConfigurationError.__proto__ || (0, _getPrototypeOf2.default)(InvalidConfigurationError)).apply(this, arguments));
  }

  return InvalidConfigurationError;
}(_extendableBuiltin(Error));

exports.InvalidConfigurationError = InvalidConfigurationError;

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3867f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("FOBA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a3867f6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _Configurator = __webpack_require__("aQ+T");

var _Configurator2 = _interopRequireDefault(_Configurator);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _vueResource = __webpack_require__("8+8L");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _vueCookie = __webpack_require__("K/Lq");

var _vueCookie2 = _interopRequireDefault(_vueCookie);

var _vueScrollto = __webpack_require__("bm7V");

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _vueObserveVisibility = __webpack_require__("GBOZ");

var _vueObserveVisibility2 = _interopRequireDefault(_vueObserveVisibility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
__webpack_require__("hKoQ").polyfill();

_vue2.default.use(_vueScrollto2.default);
_vue2.default.use(_vueCookie2.default);
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueObserveVisibility2.default);
_vue2.default.http.options.emulateJSON = true;
_vue2.default.config.productionTip = false;
_vue2.default.config.devtools = true;

_vue2.default.component('configurator', _Configurator2.default);

/* eslint-disable no-new */
new _vue2.default({
    el: '#app',
    template: '<App/>',
    components: {
        App: _App2.default
    }
});

/***/ }),

/***/ "QvsL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Manifestation = undefined;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _Pricelist = __webpack_require__("oyMF");

var _Partition = __webpack_require__("pF43");

var _InvalidConfigurationError = __webpack_require__("LOsN");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Manifestation = function () {

    /**
     * @param {Partition} partition
     */
    function Manifestation(partition) {
        (0, _classCallCheck3.default)(this, Manifestation);


        /**
         * @type {Partition}
         * @private
         */
        this._partition = partition;

        /**
         * @type {string}
         * @private
         */
        this._type = '';
    }

    /**
     * @param {string} type
     */


    (0, _createClass3.default)(Manifestation, [{
        key: '_dotsOrSquaresTotalInPence',


        /**
         * @returns {number}
         */
        value: function _dotsOrSquaresTotalInPence() {
            var linearMeters = this._calculateLinearMeters();
            return Math.ceil(linearMeters * _Pricelist.Pricelist.get().manifestations.dotsOrSquares);
        }

        /**
         * @returns {number}
         */

    }, {
        key: '_opalFrostBandInPence',
        value: function _opalFrostBandInPence() {
            var linearMeters = this._calculateLinearMeters();
            // Minimum charge of £250
            if (linearMeters < 12) {
                return 25000;
            }
            return Math.ceil(linearMeters * _Pricelist.Pricelist.get().manifestations.opalFrostBand);
        }

        /**
         * @returns {number}
         */

    }, {
        key: '_opalFrostFullInPence',
        value: function _opalFrostFullInPence() {
            if (!this._partition.hasValidDimensions) {
                throw new _InvalidConfigurationError.InvalidConfigurationError();
            }

            var surfaceArea = this._partition.glassSurfaceArea;
            // Minimum charge of £250
            if (surfaceArea < 12) {
                return 25000;
            }
            return Math.ceil(surfaceArea * _Pricelist.Pricelist.get().manifestations.opalFrostFull);
        }

        /**
         * @returns {number}
         * @private
         */

    }, {
        key: '_calculateLinearMeters',
        value: function _calculateLinearMeters() {
            var linearMeters = 0;
            switch (this._partition.type) {
                case this._partition.inlineType:
                    linearMeters = this._partition._widthWithWastage;
                    break;
                case this._partition.cornerType:
                    linearMeters = this._partition._widthWithWastage + this._partition._depthWithWastage;
                    break;
                case this._partition.threeSidedType:
                case this._partition.tShapeType:
                    linearMeters = this._partition._widthWithWastage + this._partition._depthWithWastage * 2;
                    break;
            }
            // Dimensions are in mm
            return Math.ceil(linearMeters / 1000);
        }
    }, {
        key: 'type',
        set: function set(type) {
            this._type = type;
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'dotsOrSquares',
        get: function get() {
            return 'dotsOrSquares';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'opalFrostBand',
        get: function get() {
            return 'opalFrostBand';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'opalFrostFull',
        get: function get() {
            return 'opalFrostFull';
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'totalInPence',
        get: function get() {
            if (!this._partition.hasValidDimensions) {
                throw new _InvalidConfigurationError.InvalidConfigurationError();
            }

            switch (this._type) {
                case this.dotsOrSquares:
                    return this._dotsOrSquaresTotalInPence();
                case this.opalFrostBand:
                    return this._opalFrostBandInPence();
                case this.opalFrostFull:
                    return this._opalFrostFullInPence();
                default:
                    throw new _InvalidConfigurationError.InvalidConfigurationError();
            }
        }
    }]);
    return Manifestation;
}();

exports.Manifestation = Manifestation;

/***/ }),

/***/ "XyFP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidGlazingTypeError = undefined;

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _construct = __webpack_require__("pQ2V");

var _construct2 = _interopRequireDefault(_construct);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = (0, _construct2.default)(cls, (0, _from2.default)(arguments));
    (0, _setPrototypeOf2.default)(instance, (0, _getPrototypeOf2.default)(this));
    return instance;
  }

  ExtendableBuiltin.prototype = (0, _create2.default)(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_setPrototypeOf2.default) {
    (0, _setPrototypeOf2.default)(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var InvalidGlazingTypeError = function (_extendableBuiltin2) {
  (0, _inherits3.default)(InvalidGlazingTypeError, _extendableBuiltin2);

  function InvalidGlazingTypeError() {
    (0, _classCallCheck3.default)(this, InvalidGlazingTypeError);
    return (0, _possibleConstructorReturn3.default)(this, (InvalidGlazingTypeError.__proto__ || (0, _getPrototypeOf2.default)(InvalidGlazingTypeError)).apply(this, arguments));
  }

  return InvalidGlazingTypeError;
}(_extendableBuiltin(Error));

exports.InvalidGlazingTypeError = InvalidGlazingTypeError;

/***/ }),

/***/ "Z22R":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator"},[_c('div',{staticClass:"configurator"},[_c('div',{staticClass:"configurator-section type-of-partition-section"},[_c('div',{attrs:{"id":"type-of-partition-section-anchor"}}),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 section-intro"},[_c('h3',[_vm._v("1")]),_vm._v(" "),_c('h2',[_vm._v("Type of Partition")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.typeOfPartitionText1))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-right",attrs:{"src":"/-/themes/main/client/dist/img/arrow-02.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.partitionType == _vm.partition.inlineType ? _vm.activeClass : '',attrs:{"data-partition-type":_vm.partition.inlineType},on:{"click":function($event){return _vm.setPartitionType(_vm.partition.inlineType)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/inline-glass-box.png'}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.partition.inlineType))])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.partitionType == _vm.partition.cornerType ? _vm.activeClass : '',attrs:{"data-partition-type":_vm.partition.cornerType},on:{"click":function($event){return _vm.setPartitionType(_vm.partition.cornerType)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/corner-glass-box.png'}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.partition.cornerType))])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.partitionType == _vm.partition.threeSidedType ? _vm.activeClass : '',attrs:{"data-partition-type":_vm.partition.threeSidedType},on:{"click":function($event){return _vm.setPartitionType(_vm.partition.threeSidedType)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/three-sided-glass-box.png'}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.partition.threeSidedType))])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.partitionType == _vm.partition.tShapeType ? _vm.activeClass : '',attrs:{"data-partition-type":_vm.partition.tShapeType},on:{"click":function($event){return _vm.setPartitionType(_vm.partition.tShapeType)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/t-glass-box.png'}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.partition.tShapeType))])])])]),_vm._v(" "),_c('div',{staticClass:"row section-outro"},[_c('div',{staticClass:"col-12 col-lg-9"},[_c('p',[_vm._v(_vm._s(_vm.typeOfPartitionText2))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('div',{staticClass:"button-wrapper"},[_c('a',{staticClass:"btn btn-outline-black configurator-btn",attrs:{"href":_vm.guideToPartitionsLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.guideToPartitionsLinkText))])])])])])]),_vm._v(" "),_c('div',{staticClass:"dimensions",staticStyle:{"background-image":"url('/-/themes/main/client/dist/img/dimensions-bg.jpg')"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 section-intro"},[_c('h3',[_vm._v("2")]),_vm._v(" "),_c('h2',[_vm._v("Dimensions")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.dimensionsText))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-left",attrs:{"src":"/-/themes/main/client/dist/img/arrow-01.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12 dimension-row",class:_vm.notInlinePartition ? 'col-lg-4' : 'col-lg-6'},[_c('div',{staticClass:"form-group has-danger",attrs:{"data-label":"Width"}},[_vm._m(0),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.width),expression:"width",modifiers:{"number":true}}],staticClass:"form-control",class:{ 'form-control-danger': _vm.widthWarning },attrs:{"id":"partitionWidth","type":"number","min":"1"},domProps:{"value":(_vm.width)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.width=_vm._n($event.target.value)},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.widthWarning)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.widthWarning))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 dimension-row",class:_vm.notInlinePartition ? 'col-lg-4' : 'col-lg-6'},[_c('div',{staticClass:"form-group has-danger",attrs:{"data-label":"Height"}},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.height),expression:"height",modifiers:{"number":true}}],staticClass:"form-control",class:{ 'form-control-danger': _vm.heightWarning },attrs:{"id":"partitionHeight","type":"number","min":"1"},domProps:{"value":(_vm.height)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.height=_vm._n($event.target.value)},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.heightWarning)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.heightWarning))]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 dimension-row",class:_vm.notInlinePartition ? 'col-lg-4' : 'col-lg-6'},[(_vm.notInlinePartition)?_c('div',{staticClass:"form-group has-danger",attrs:{"data-label":"Depth"}},[_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.depth),expression:"depth",modifiers:{"number":true}}],staticClass:"form-control",class:{ 'form-control-danger': _vm.depthWarning },attrs:{"id":"partitionDepth","type":"number","min":"1"},domProps:{"value":(_vm.depth)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.depth=_vm._n($event.target.value)},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),(_vm.depthWarning)?_c('div',{staticClass:"form-control-feedback"},[_vm._v(_vm._s(_vm.depthWarning))]):_vm._e()]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"configurator-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-6 section-intro"},[_c('h3',[_vm._v("3")]),_vm._v(" "),_c('h2',[_vm._v("Glass")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.glassText))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-right",attrs:{"src":"/-/themes/main/client/dist/img/arrow-02.png"}}),_vm._v(" "),_c('div',{staticClass:"button-wrapper"},[_c('a',{staticClass:"btn btn-outline-black configurator-btn",attrs:{"href":_vm.guideToAcousticsLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.guideToAcousticsLinkText))])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-6"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"configurator-tile",class:_vm.glazingType == _vm.partition.singleGlazingType ? _vm.activeClass : '',attrs:{"data-glazing-type":_vm.partition.singleGlazingType},on:{"click":function($event){return _vm.setGlazingType(_vm.partition.singleGlazingType)}}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/glass-single.png"}}),_vm._v(" "),_c('p',[_vm._v("Single Glazed")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"configurator-tile",class:_vm.glazingType == _vm.partition.doubleGlazingType ? _vm.activeClass : '',attrs:{"data-glazing-type":_vm.partition.doubleGlazingType},on:{"click":function($event){return _vm.setGlazingType(_vm.partition.doubleGlazingType)}}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/glass-double.png"}}),_vm._v(" "),_c('p',[_vm._v("Double Glazed")])])])])])]),_vm._v(" "),(_vm.glazingType == _vm.partition.singleGlazingType)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-lg-6 order-1 order-lg-2 section-intro pt-5"},[_c('h2',[_vm._v("Acoustic Performance")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.acousticPerformanceText))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-left",attrs:{"src":"/-/themes/main/client/dist/img/arrow-01.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-lg-6 order-2 order-lg-1 pt-5"},[_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"configurator-tile",class:_vm.acousticPerformance == _vm.partition.singleGlazed33dB ? _vm.activeClass : '',attrs:{"data-acoustic-performance":_vm.partition.singleGlazed33dB},on:{"click":function($event){return _vm.setAcousticPerformance(_vm.partition.singleGlazed33dB)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/single-glazed-33db.png'}}),_vm._v(" "),_c('p',[_vm._v("Toughened")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"configurator-tile",class:_vm.acousticPerformance == _vm.partition.singleGlazed38dB ? _vm.activeClass : '',attrs:{"data-acoustic-performance":_vm.partition.singleGlazed38dB},on:{"click":function($event){return _vm.setAcousticPerformance(_vm.partition.singleGlazed38dB)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/single-glazed-38db.png'}}),_vm._v(" "),_c('p',[_vm._v("Acoustic Laminated")])])])])])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"configurator-section doors-section"},[_c('div',{staticClass:"container d-lg-none"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 section-intro"},[_c('h3',[_vm._v("4")]),_vm._v(" "),_c('h2',[_vm._v("Select a door")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.doorText))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-left",attrs:{"src":"/-/themes/main/client/dist/img/arrow-01.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._l((_vm.singleGlazedDoorOptions),function(description,option){return (_vm.isSingleGlazed)?_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.door == option ? _vm.activeClass : '',attrs:{"data-door-type":option},on:{"click":function($event){return _vm.setDoor(option)}}},[_c('img',{attrs:{"src":description.imgPathSmall}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(description.name))])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.doubleGlazedDoorOptions),function(description,option){return (_vm.isDoubleGlazed)?_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.door == option ? _vm.activeClass : '',attrs:{"data-door-type":option},on:{"click":function($event){return _vm.setDoor(option)}}},[_c('img',{attrs:{"src":description.imgPathSmall}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(description.name))])])]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"row section-outro"},[_c('div',{staticClass:"col-12 col-lg-12"},[_c('div',{staticClass:"button-wrapper"},[_c('a',{staticClass:"btn btn-filled-black configurator-btn",attrs:{"href":_vm.guideToDoorsLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.guideToDoorsLinkText))])])])])]),_vm._v(" "),_c('div',{staticClass:"d-none d-lg-block large-doors"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('table',{staticClass:"door-controls"},[_c('tr',[_vm._l((_vm.singleGlazedDoorOptions),function(description,option){return (_vm.isSingleGlazed)?_c('td',{attrs:{"data-door-type":option},on:{"click":function($event){return _vm.setDoor(option, description.imgPathLarge)}}},[_vm._v("\n                                        "+_vm._s(description.name)+"\n                                    ")]):_vm._e()}),_vm._v(" "),_vm._l((_vm.doubleGlazedDoorOptions),function(description,option){return (_vm.isDoubleGlazed)?_c('td',{attrs:{"data-door-type":option},on:{"click":function($event){return _vm.setDoor(option, description.imgPathLarge)}}},[_vm._v("\n                                        "+_vm._s(description.name)+"\n                                    ")]):_vm._e()})],2)]),_vm._v(" "),_c('img',{staticClass:"door-image base-door-image",attrs:{"src":_vm.baseDoorImage}}),_vm._v(" "),_vm._l((_vm.singleGlazedDoorOptions),function(description,option){return [_c('img',{staticClass:"door-image selected-door-image",class:{ show: _vm.door === option},attrs:{"src":description.imgPathLarge}})]}),_vm._v(" "),_vm._l((_vm.doubleGlazedDoorOptions),function(description,option){return [_c('img',{staticClass:"door-image selected-door-image",class:{ show: _vm.door === option},attrs:{"src":description.imgPathLarge}})]})],2),_vm._v(" "),_c('div',{staticClass:"col-3 information"},[_c('h2',[_vm._v("Select a door")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.doorText))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-left",attrs:{"src":"/-/themes/main/client/dist/img/arrow-01.png"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-filled-black configurator-btn",attrs:{"data-link":_vm.guideToDoorsLink,"id":"guide-to-doors"}},[_vm._v(_vm._s(_vm.guideToDoorsLinkText)+"\n                            ")])])])])])]),_vm._v(" "),(_vm.door !== _vm.partition.door.noDoor)?_c('div',{staticClass:"configurator-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 section-intro section-intro--no-number"},[_c('h2',[_vm._v("Ironmongery")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.ironmongeryText1))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-left",attrs:{"src":"/-/themes/main/client/dist/img/arrow-01.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.ironmongery == _vm.partition.door.ironmongeryDHandle ? _vm.activeClass : '',attrs:{"data-ironmongery":_vm.partition.door.ironmongeryDHandle},on:{"click":function($event){return _vm.setIronmongery(_vm.partition.door.ironmongeryDHandle)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/d-handles.png'}}),_vm._v(" "),_c('p',[_vm._v("D Handle")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.ironmongery == _vm.partition.door.ironmongeryManet ? _vm.activeClass : '',attrs:{"data-ironmongery":_vm.partition.door.ironmongeryManet},on:{"click":function($event){return _vm.setIronmongery(_vm.partition.door.ironmongeryManet)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/manet-pull-handles.png'}}),_vm._v(" "),_c('p',[_vm._v("Manet")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.ironmongery == _vm.partition.door.ironmongeryLeverLock ? _vm.activeClass : '',attrs:{"data-ironmongery":_vm.partition.door.ironmongeryLeverLock},on:{"click":function($event){return _vm.setIronmongery(_vm.partition.door.ironmongeryLeverLock)}}},[_c('img',{attrs:{"src":'/-/themes/main/client/dist/img/lever-locking-handles.png'}}),_vm._v(" "),_c('p',[_vm._v("Lever Lock")])])])]),_vm._v(" "),_c('div',{staticClass:"row section-outro"},[_c('div',{staticClass:"col-12 col-lg-9"},[_c('p',[_vm._v(_vm._s(_vm.ironmongeryText2))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('div',{staticClass:"button-wrapper"},[_c('a',{staticClass:"btn btn-outline-black configurator-btn",attrs:{"href":_vm.guideToIronmongeryLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.guideToIronmongeryLinkText))])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"configurator-section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 section-intro"},[_c('h3',[_vm._v("6")]),_vm._v(" "),_c('h2',[_vm._v("Manifestations")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.manifestationsText1))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-left",attrs:{"src":"/-/themes/main/client/dist/img/arrow-01.png"}})])]),_vm._v(" "),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.manifestation == 'dots' ? _vm.activeClass : '',attrs:{"data-manifestation-type":'dots'},on:{"click":function($event){return _vm.setManifestation('dots')}}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/manifestations-dots.png"}}),_vm._v(" "),_c('p',[_vm._v("Dots")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.manifestation == 'squares' ? _vm.activeClass : '',attrs:{"data-manifestation-type":'squares'},on:{"click":function($event){return _vm.setManifestation('squares')}}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/manifestations-squares.png"}}),_vm._v(" "),_c('p',[_vm._v("Squares")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.manifestation == 'opalFrostBand' ? _vm.activeClass : '',attrs:{"data-manifestation-type":'opalFrostBand'},on:{"click":function($event){return _vm.setManifestation('opalFrostBand')}}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/manifestations-opal-band.png"}}),_vm._v(" "),_c('p',[_vm._v("Opal Frost Band")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 col-lg-3"},[_c('div',{staticClass:"configurator-tile",class:_vm.manifestation == 'opalFrostFull' ? _vm.activeClass : '',attrs:{"data-manifestation-type":'opalFrostFull'},on:{"click":function($event){return _vm.setManifestation('opalFrostFull')}}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/manifestations-opal-full.png"}}),_vm._v(" "),_c('p',[_vm._v("Opal Frost Full Cover")])])])]),_vm._v(" "),_c('div',{staticClass:"row section-outro"},[_c('div',{staticClass:"col-12 col-lg-9"},[_c('p',[_vm._v(_vm._s(_vm.manifestationsText2))])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-3"},[_c('div',{staticClass:"button-wrapper"},[_c('a',{staticClass:"btn btn-outline-black configurator-btn",attrs:{"href":_vm.guideToManifestationsLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.guideToManifestationsLinkText))])])])])])]),_vm._v(" "),_c('div',{staticClass:"your-configuration"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row introduction"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("Your configuration")]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-right",attrs:{"src":"/-/themes/main/client/dist/img/arrow-02.png"}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.yourConfigurationText))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('hr',{staticClass:"d-md-none"}),_vm._v(" "),_c('div',{staticClass:"partition-summary d-lg-none"},[_c('table',{staticClass:"partition-details"},[_c('tbody',[_c('tr',[_c('th',[_vm._v("Type of Partition")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.partitionType))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Width")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.width)+"m")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Height")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.height)+"m")])]),_vm._v(" "),(_vm.partitionType !== _vm.partition.inlineType)?_c('tr',[_c('th',[_vm._v("Depth")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.depth)+"m")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Glass")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.glazingTypeString()))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Door")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.doorString()))])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Manifestation")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.manifestationString()))])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('tr',{staticClass:"estimate current-configuration"},[_c('td',[_c('p',[_vm._v("Cost (Estimate)")]),_vm._v(" "),(_vm.showTotals)?_c('p',{staticClass:"cost"},[_vm._v("£"+_vm._s(_vm.currentConfigurationTotal))]):_c('p',{staticClass:"cost cost-description"},[_vm._v(_vm._s(_vm.contactForQuoteText))])]),_vm._v(" "),_c('td',[_c('p',{staticClass:"quantity"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.quantity),expression:"quantity",modifiers:{"number":true}}],staticClass:"form-control current-configuration",attrs:{"id":"current-quantity-mobile","type":"number","min":"1"},domProps:{"value":(_vm.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.quantity=_vm._n($event.target.value)},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._l((_vm.savedPartitions),function(data,index){return [_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Type of Partition")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Type of Partition"}},[_vm._v(_vm._s(data.partitionType))])])]),_vm._v(" "),_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Width")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Width"}},[_vm._v(_vm._s(data.width)+"m")])])]),_vm._v(" "),_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Height")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Height"}},[_vm._v(_vm._s(data.height)+"m")])])]),_vm._v(" "),(data.partitionType !== _vm.partition.inlineType)?_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Depth")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Depth"}},[_vm._v(_vm._s(data.depth))])])]):_vm._e(),_vm._v(" "),_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Glass")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Glazing Type"}},[_vm._v(_vm._s(_vm.glazingTypeString(data.glazingType, data.acousticPerformance)))])])]),_vm._v(" "),_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Door")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Door Type"}},[_vm._v(_vm._s(_vm.doorString(data.door,
                                                data.ironmongery)))])])]),_vm._v(" "),_c('tr',{attrs:{"data-table-row":index}},[_c('th',[_vm._v("Manifestation")]),_vm._v(" "),_c('td',[_c('p',{attrs:{"data-heading":"Manifestation Type"}},[_vm._v(_vm._s(_vm.manifestationString(data.manifestation)))])])]),_vm._v(" "),_c('tr',{staticClass:"divider-row"},[_vm._m(6,true)]),_vm._v(" "),_c('tr',{staticClass:"estimate",attrs:{"data-table-row":index,"data-row-count":index}},[_c('td',[_c('p',[_vm._v("Cost (Estimate)")]),_vm._v(" "),(_vm.showTotals)?_c('p',{staticClass:"cost",attrs:{"data-heading":"Cost"}},[_vm._v("£"+_vm._s(data.grandTotal))]):_c('p',{staticClass:"cost cost-description",attrs:{"data-heading":"Cost"}},[_vm._v(_vm._s(_vm.contactForQuoteText))])]),_vm._v(" "),_c('td',[_c('p',{staticClass:"quantity"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(data.quantity),expression:"data.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(data.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(data, "quantity", _vm._n($event.target.value))},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}}),_vm._v(" "),_c('div',{staticClass:"remove-btn d-flex align-items-center",attrs:{"data-table-row":index},on:{"click":function($event){return _vm.removeSavedPartition(index)}}},[_vm._m(7,true)])])]),_vm._v(" "),_c('tr',{staticClass:"divider-row"},[_vm._m(8,true)])]})],2)])]),_vm._v(" "),_c('div',{staticClass:"partition-summary desktop-partition-summary d-none d-lg-block"},[_c('table',{staticClass:"partition-details"},[_vm._m(9),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('img',{attrs:{"src":_vm.partitionTypeImgPath(_vm.partitionType)}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.partitionType))])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/dimensions-arrow.png"}}),_vm._v(" "),_c('p',[_vm._v("Width: "+_vm._s(_vm.width)+"m")]),_vm._v(" "),_c('p',[_vm._v("Height: "+_vm._s(_vm.height)+"m")]),_vm._v(" "),(_vm.partitionType !== _vm.partition.inlineType)?_c('p',[_vm._v("Depth: "+_vm._s(_vm.depth)+"m")]):_vm._e()]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.glazingTypeImgPath(_vm.glazingType)}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.glazingTypeString()))])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.doorImgPath()}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.doorString()))])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.manifestationImgPath()}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.manifestationString()))])]),_vm._v(" "),_c('td',{staticClass:"cost-and-quantity current-configuration"},[(_vm.showTotals)?_c('p',{staticClass:"cost"},[_vm._v("£"+_vm._s(_vm.currentConfigurationTotal))]):_c('p',{staticClass:"cost cost-description"},[_vm._v(_vm._s(_vm.contactForQuoteText))]),_vm._v(" "),_c('p',{staticClass:"quantity"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.quantity),expression:"quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"id":"current-quantity","type":"number","min":"1"},domProps:{"value":(_vm.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.quantity=_vm._n($event.target.value)},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._l((_vm.savedPartitions),function(data,index){return [_c('tr',[_c('th',[_vm._v("Type of Partition")]),_vm._v(" "),_c('th',[_vm._v("Dimensions")]),_vm._v(" "),_c('th',[_vm._v("Glass")]),_vm._v(" "),_c('th',[_vm._v("Door")]),_vm._v(" "),_c('th',[_vm._v("Manifestation")]),_vm._v(" "),_c('th',{staticClass:"cost-and-quantity"},[_vm._v("Cost (Estimate)")]),_vm._v(" "),_c('td',{staticClass:"pos-relative",attrs:{"rowspan":"2"}},[_c('div',{staticClass:"remove-btn d-flex align-items-center",attrs:{"data-table-row":index},on:{"click":function($event){return _vm.removeSavedPartition(index)}}},[_vm._m(11,true)])])]),_vm._v(" "),_c('tr',{attrs:{"data-table-row":index}},[_c('td',[_c('img',{attrs:{"src":_vm.partitionTypeImgPath(data.partitionType)}}),_vm._v(" "),_c('p',{attrs:{"data-heading":"Type of Partition"}},[_vm._v(_vm._s(data.partitionType))])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/dimensions-arrow.png"}}),_vm._v(" "),_c('p',{attrs:{"data-heading":"Width"}},[_vm._v("Width: "+_vm._s(data.width)+"m")]),_vm._v(" "),_c('p',{attrs:{"data-heading":"Height"}},[_vm._v("Height: "+_vm._s(data.height)+"m")]),_vm._v(" "),(data.partitionType !== _vm.partition.inlineType)?_c('p',{attrs:{"data-heading":"Depth"}},[_vm._v("Depth: "+_vm._s(data.depth)+"m")]):_vm._e()]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.glazingTypeImgPath(data.glazingType)}}),_vm._v(" "),_c('p',{attrs:{"data-heading":"Glazing Type"}},[_vm._v("\n                                                    "+_vm._s(_vm.glazingTypeString(data.glazingType, data.acousticPerformance))+"\n                                                ")])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.doorImgPath(data.door)}}),_vm._v(" "),_c('p',{attrs:{"data-heading":"Door Type"}},[_vm._v("\n                                                    "+_vm._s(_vm.doorString(data.door, data.ironmongery))+"\n                                                ")])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":_vm.manifestationImgPath(data.manifestation)}}),_vm._v(" "),_c('p',{attrs:{"data-heading":"Manifestation Type"}},[_vm._v("\n                                                    "+_vm._s(_vm.manifestationString(data.manifestation))+"\n                                                ")])]),_vm._v(" "),_c('td',{staticClass:"cost-and-quantity",attrs:{"data-row-count":index}},[(_vm.showTotals)?_c('p',{staticClass:"cost",attrs:{"data-heading":"Cost"}},[_vm._v("£"+_vm._s(_vm.grandTotal))]):_c('p',{staticClass:"cost cost-description",attrs:{"data-heading":"Cost"}},[_vm._v(_vm._s(_vm.contactForQuoteText))]),_vm._v(" "),_c('p',{staticClass:"quantity"},[_vm._v("Quantity")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(data.quantity),expression:"data.quantity",modifiers:{"number":true}}],staticClass:"form-control",attrs:{"type":"number","min":"1"},domProps:{"value":(data.quantity)},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(data, "quantity", _vm._n($event.target.value))},function($event){return _vm.updateTotalOfAllPartitions()}],"blur":function($event){return _vm.$forceUpdate()}}})])]),_vm._v(" "),_c('tr',{staticClass:"divider-row"},[_vm._m(12,true)])]})],2)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('a',{staticClass:"add-partition",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.savePartition()}}},[_vm._v("Add Another\n                            Partition "),_c('i',{staticClass:"fa fa-plus"})]),_vm._v(" "),_c('hr')])])])]),_vm._v(" "),_c('div',{staticClass:"summary"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v("Total Estimate")]),_vm._v(" "),_c('p',{staticClass:"above-price-text"},[_vm._v(_vm._s(_vm.totalEstimateText))]),_vm._v(" "),(_vm.showTotals)?_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:({callback: _vm.totalPriceVisibilityChanged}),expression:"{callback: totalPriceVisibilityChanged}"}]},[(_vm.dimensionsAreValid)?_c('h3',{staticClass:"total-price"},[_c('ICountUp',{attrs:{"delay":_vm.countupDelay,"endVal":_vm.totalOfAllPartitions,"options":_vm.countupOptions}})],1):_vm._e()]):_c('p',{staticClass:"total-price-description"},[_vm._v(_vm._s(_vm.contactForQuoteText))]),_vm._v(" "),_c('p',{staticClass:"above-submit-text"},[_vm._v(_vm._s(_vm.aboveSubmitText))]),_vm._v(" "),(_vm.dimensionsAreValid)?_c('a',{staticClass:"btn btn-large submit-button",attrs:{"href":"javascript:void(0);","id":"submit-quote"},on:{"click":function($event){return _vm.scrollToYourDetails()}}},[_vm._v("Submit")]):_vm._e(),_vm._v(" "),(_vm.dimensionsAreValid === false)?_c('p',{staticClass:"invalid-dimensions",attrs:{"id":"invalid-dimensions-submit"}},[_vm._v("Dimensions are invalid")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"container contact-buttons"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-4"},[_c('a',{attrs:{"href":'tel: ' + _vm.phoneNumber}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/get-in-touch-icon-02.png"}}),_vm._v("Call")])]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-4"},[_c('a',{attrs:{"href":'mailto: ' + _vm.contactEmail,"target":"_blank"}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/get-in-touch-icon-04.png"}}),_vm._v("Email")])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"your-details"},[_c('div',{attrs:{"id":"your-details-anchor"}}),_vm._v(" "),(_vm.showYourDetailsSection)?_c('div',{staticClass:"your-details-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 description"},[_c('h2',[_vm._v("Your details")]),_vm._v(" "),_c('p',{staticClass:"description-text"},[_vm._v(_vm._s(_vm.yourDetailsText))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-right",attrs:{"src":"/-/themes/main/client/dist/img/arrow-02.png"}})]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"name"}},[_vm._v("Name*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.yourDetails.name),expression:"yourDetails.name"}],staticClass:"form-control",attrs:{"type":"text","id":"name","required":""},domProps:{"value":(_vm.yourDetails.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.yourDetails, "name", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"email"}},[_vm._v("Email address")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.yourDetails.email),expression:"yourDetails.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","required":""},domProps:{"value":(_vm.yourDetails.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.yourDetails, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"location"}},[_vm._v("Location*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.yourDetails.location),expression:"yourDetails.location"}],staticClass:"form-control",attrs:{"type":"text","id":"location","required":""},domProps:{"value":(_vm.yourDetails.location)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.yourDetails, "location", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-lg-6"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"phone"}},[_vm._v("Phone*")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.yourDetails.phone),expression:"yourDetails.phone"}],staticClass:"form-control",attrs:{"type":"text","id":"phone","required":""},domProps:{"value":(_vm.yourDetails.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.yourDetails, "phone", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"howDidYouHearAboutUs"}},[_vm._v("How did you hear about us")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.yourDetails.howDidYouHearAboutUs),expression:"yourDetails.howDidYouHearAboutUs"}],staticClass:"form-control",attrs:{"id":"howDidYouHearAboutUs"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.yourDetails, "howDidYouHearAboutUs", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"disabled":"","value":""}},[_vm._v("Please select one")]),_vm._v(" "),_c('option',[_vm._v("Google")]),_vm._v(" "),_c('option',[_vm._v("Radio (LBC)")]),_vm._v(" "),_c('option',[_vm._v("Social Media")]),_vm._v(" "),_c('option',[_vm._v("Referral")]),_vm._v(" "),_c('option',[_vm._v("Online Advertisement")]),_vm._v(" "),_c('option',[_vm._v("Other")])])])]),_vm._v(" "),_vm._m(14)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 complete-button-div"},[_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.acceptedTerms),expression:"acceptedTerms"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"accept-terms","value":""},domProps:{"checked":Array.isArray(_vm.acceptedTerms)?_vm._i(_vm.acceptedTerms,"")>-1:(_vm.acceptedTerms)},on:{"change":function($event){var $$a=_vm.acceptedTerms,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.acceptedTerms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.acceptedTerms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.acceptedTerms=$$c}}}}),_vm._v("\n                                    I confirm that I have read and accept The Glass Office People's "),_c('a',{attrs:{"href":"/privacy-policy","target":"_blank"}},[_vm._v("Privacy Policy")]),_vm._v(" and "),_c('a',{attrs:{"href":"/terms-and-conditions","target":"_blank"}},[_vm._v("Terms and\n                                    Conditions")])])]),_vm._v(" "),_c('div',{staticClass:"form-check form-check-inline"},[_c('label',{staticClass:"form-check-label"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.yourDetails.promotionalConsent),expression:"yourDetails.promotionalConsent"}],staticClass:"form-check-input",attrs:{"type":"checkbox","id":"promotional-consent","value":""},domProps:{"checked":Array.isArray(_vm.yourDetails.promotionalConsent)?_vm._i(_vm.yourDetails.promotionalConsent,"")>-1:(_vm.yourDetails.promotionalConsent)},on:{"change":function($event){var $$a=_vm.yourDetails.promotionalConsent,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.yourDetails, "promotionalConsent", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.yourDetails, "promotionalConsent", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.yourDetails, "promotionalConsent", $$c)}}}}),_vm._v("\n                                    I give permission for The Glass Office People to send me promotional e-mail messages with offers and updates. Your information will be used in accordance to our Privacy Policy\n                                ")])]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center pt-4 pb-3"},[_c('vue-recaptcha',{attrs:{"sitekey":"6LdqIzsUAAAAAEARn-6EzPbyYWp8csl5UALg57B8"},on:{"verify":_vm.recaptchaVerify,"expired":_vm.recaptchaExpired}})],1),_vm._v(" "),(_vm.dimensionsAreValid)?_c('button',{staticClass:"btn btn-large submit-button my-4",class:{ formSubmitted: _vm.submittedForm },attrs:{"id":"complete-quote","disabled":_vm.acceptedTerms !== true || _vm.recaptchaVerified !== true || _vm.submittedForm === true || _vm.yourDetails.howDidYouHearAboutUs === ''},on:{"click":function($event){return _vm.completeQuote()}}},[_vm._v("\n                                "+_vm._s(_vm.submitQuoteText)+" "),_c('i',{domProps:{"innerHTML":_vm._s(_vm.submitIcon)}})]):_vm._e(),_vm._v(" "),(_vm.acceptedTerms !== true)?_c('p',{staticClass:"description-text text-center mx-auto"},[_vm._v("Please accept the terms and conditions")]):_vm._e(),_vm._v(" "),(_vm.yourDetailsFormFilledIn === false)?_c('p',{staticClass:"description-text text-center mx-auto"},[_vm._v(_vm._s(_vm.pleaseFillInYourDetailsText))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"description-text text-center mx-auto"},[_vm._v(_vm._s(_vm.completeQuoteText))]),_vm._v(" "),_c('div',{staticClass:"bottom-line mt-5"})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"finance"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 description"},[_c('h2',[_vm._v("Additional products")]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-right",attrs:{"src":"/-/themes/main/client/dist/img/arrow-02.png"}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.additionalProductsText)}}),_vm._v(" "),_c('div',{staticClass:"bottom-line"}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.financeHeading))]),_vm._v(" "),_c('img',{staticClass:"arrow arrow-right",attrs:{"src":"/-/themes/main/client/dist/img/arrow-02.png"}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.financeText)}}),_vm._v(" "),_c('div',{staticClass:"bottom-line"})])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"partitionWidth"}},[_vm._v("Width "),_c('span',{staticClass:"mm"},[_vm._v("mm")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"partitionHeight"}},[_vm._v("Height "),_c('span',{staticClass:"mm"},[_vm._v("mm")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"partitionDepth"}},[_vm._v("Depth "),_c('span',{staticClass:"mm"},[_vm._v("mm")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1"},[_c('h3',[_vm._v("4")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"divider-row"},[_c('td',{attrs:{"colspan":"3"}},[_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"divider-row"},[_c('td',{attrs:{"colspan":"3"}},[_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"3"}},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1"},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "),_c('p',[_vm._v("Remove")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"3"}},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_vm._v("Type of Partition")]),_vm._v(" "),_c('th',[_vm._v("Dimensions")]),_vm._v(" "),_c('th',[_vm._v("Glass")]),_vm._v(" "),_c('th',[_vm._v("Door")]),_vm._v(" "),_c('th',[_vm._v("Manifestation")]),_vm._v(" "),_c('th',{staticClass:"cost-and-quantity"},[_vm._v("Cost (Estimate)")]),_vm._v(" "),_c('td',{staticClass:"pos-relative",attrs:{"rowspan":"2"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:"divider-row"},[_c('td',{attrs:{"colspan":"7"}},[_c('hr')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1"},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" "),_c('p',[_vm._v("Remove")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"colspan":"7"}},[_c('hr')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-4"},[_c('a',{staticClass:"open-chat",attrs:{"href":"javascript:void(0);"}},[_c('img',{attrs:{"src":"/-/themes/main/client/dist/img/get-in-touch-icon-03.png"}}),_vm._v("Live chat")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pt-3 text-center"},[_c('p',[_vm._v("Complete this form and click \"Complete Quote\" to have your quote emailed to you")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aQ+T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configurator_vue__ = __webpack_require__("wIMY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configurator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configurator_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configurator_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configurator_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99219332_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configurator_vue__ = __webpack_require__("Z22R");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Configurator_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99219332_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Configurator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "jbNl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Configuration = undefined;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Configuration = function () {
    function Configuration() {
        (0, _classCallCheck3.default)(this, Configuration);
    }

    (0, _createClass3.default)(Configuration, null, [{
        key: 'get',
        value: function get() {
            return {
                'singleGlazed': {
                    'trackComponents': ['singleGlazedHeadTrack', 'singleGlazedHeadTrackGasket', 'singleGlazedBaseTrack', 'singleGlazedCoverPlates'],
                    'abutmentComponents': ['singleGlazedStandardWallAbutment', 'singleGlazedWallAbutmentGasket'],
                    'doors': ['noDoor', 'singleGlazedDoorFrameless', 'singleGlazedDoorIncFrame']
                },
                'doubleGlazed': {
                    'trackComponents': ['doubleGlazedHeadTrack', 'doubleGlazedHeadTrackGasket', 'doubleGlazedBaseTrack', 'doubleGlazedCoverPlates'],
                    'abutmentComponents': ['doubleGlazedStandardWallAbutment', 'doubleGlazedStandardWallAbutmentGasket'],
                    'doors': ['noDoor', 'singleGlazedDoorIncDoubleGlazedFrame', 'doubleGlazedDoor']
                }
            };
        }
    }]);
    return Configuration;
}();

exports.Configuration = Configuration;

/***/ }),

/***/ "oeo/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createApp */
/* unused harmony export Vue2 */
/* unused harmony export isVue2 */
/* unused harmony export isVue3 */
/* unused harmony export install */
/* unused harmony export warn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* unused harmony reexport Vue */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["defineComponent"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["ref"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["onMounted"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_vue__["h"]; });


var isVue2 = true
var isVue3 = false
var Vue2 = __WEBPACK_IMPORTED_MODULE_0_vue__["default"]
var warn = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].util.warn

function install() {}

// createApp polyfill
function createApp(rootComponent, rootProps) {
  var vm
  var provide = {}
  var app = {
    config: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].config,
    use: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].use.bind(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]),
    mixin: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin.bind(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]),
    component: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component.bind(__WEBPACK_IMPORTED_MODULE_0_vue__["default"]),
    provide: function (key, value) {
      provide[key] = value
      return this
    },
    directive: function (name, dir) {
      if (dir) {
        __WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive(name, dir)
        return app
      } else {
        return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive(name)
      }
    },
    mount: function (el, hydrating) {
      if (!vm) {
        vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"](Object.assign({ propsData: rootProps }, rootComponent, { provide: Object.assign(provide, rootComponent.provide) }))
        vm.$mount(el, hydrating)
        return vm
      } else {
        return vm
      }
    },
    unmount: function () {
      if (vm) {
        vm.$destroy()
        vm = undefined
      }
    },
  }
  return app
}





/***/ }),

/***/ "oyMF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// All prices are listed in pence so £22 = 2200

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Pricelist = undefined;

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pricelist = function () {
    function Pricelist() {
        (0, _classCallCheck3.default)(this, Pricelist);
    }

    (0, _createClass3.default)(Pricelist, null, [{
        key: 'get',
        value: function get() {
            return {
                'fixings': {
                    'singleGlazedHeadTrack': 2200,
                    'singleGlazedHeadTrackGasket': 179,
                    'singleGlazedBaseTrack': 867,
                    'singleGlazedCoverPlates': 510,
                    'singleGlazedGaskets10mmGlass': 12,
                    'singleGlazedGaskets12mmGlass': 10,
                    'singleGlazedStandardWallAbutment': 2200,
                    'singleGlazedWallAbutmentGasket': 179,
                    'doubleGlazedHeadTrack': 2649,
                    'doubleGlazedHeadTrackGasket': 358,
                    'doubleGlazedBaseTrack': 2208,
                    'doubleGlazedCoverPlates': 1020,
                    'doubleGlazedInnerGasket': 46,
                    'doubleGlazedStandardWallAbutment': 2649,
                    'doubleGlazedStandardWallAbutmentGasket': 358
                },
                'doors': {
                    'noDoor': 0,
                    'singleGlazedDoorFrameless': 52100,
                    'singleGlazedDoorIncFrame': 74830,
                    'singleGlazedDoorIncDoubleGlazedFrame': 78790,
                    'doubleGlazedDoor': 146200
                },
                'ironmongery': {
                    'dHandle': 0,
                    'manet': 0,
                    'leverLock': 14800
                },
                'manifestations': {
                    'dotsOrSquares': 1550,
                    'opalFrostBand': 3600,
                    'opalFrostFull': 3000
                },
                'labour': {
                    'single': 1500,
                    'double': 2000,
                    'total': 25000
                },
                'margin': {
                    'singleGlazedInline': 40,
                    'singleGlazedCorner': 35,
                    'singleGlazedThreeSided': 35,
                    'singleGlazedTShape': 30,
                    'doubleGlazedInline': 20,
                    'doubleGlazedCorner': 10,
                    'doubleGlazedThreeSided': 10,
                    'doubleGlazedTShape': 10
                },
                'glass': {
                    '1': 5187, // single glazed toughened 10mm
                    '2': 7717, // single glazed toughened 12mm
                    '3': 14283, // double glazed, toughened 10mm & toughened 12mm (one sheet of each)
                    '4': 8737, // single glazed, acoustic laminate 10.8mm
                    '5': 9553 // single glazed, acoustic laminate 12.8mm
                },
                'additional': {
                    'general': 10000,
                    'delivery': 0
                }
            };
        }
    }]);
    return Pricelist;
}();

exports.Pricelist = Pricelist;

/***/ }),

/***/ "pF43":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Partition = undefined;

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _parseFloat = __webpack_require__("5dBV");

var _parseFloat2 = _interopRequireDefault(_parseFloat);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _ValueCannotBeParsedError = __webpack_require__("q5Zj");

var _InvalidConfigurationError = __webpack_require__("LOsN");

var _InvalidGlazingTypeError = __webpack_require__("XyFP");

var _Pricelist = __webpack_require__("oyMF");

var _Configuration = __webpack_require__("jbNl");

var _Manifestation = __webpack_require__("QvsL");

var _Door = __webpack_require__("0e5O");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Partition = function () {
    function Partition() {
        (0, _classCallCheck3.default)(this, Partition);


        /**
         * @type {Manifestation}
         * @private
         */
        this._manifestation = new _Manifestation.Manifestation(this);
        this._manifestation.type = this._manifestation.dotsOrSquares;

        /**
         * @type {number}
         * @private
         */
        this._width = 0;

        /**
         * @type {number}
         * @private
         */
        this._widthWithWastage = 0;

        /**
         * @type {number}
         * @private
         */
        this._height = 0;

        /**
         * @type {number}
         * @private
         */
        this._heightWithWastage = 0;

        /**
         * @type {number}
         * @private
         */
        this._depth = 0;

        /**
         * @type {number}
         * @private
         */
        this._depthWithWastage = 0;

        /**
         * @type {string}
         * @private
         */
        this._type = '';

        /**
         * @type {number}
         * @private
         */
        this._glassThickness = 0;

        /**
         * @type {string}
         * @private
         */
        this._glazingType = '';

        /**
         * @type {string}
         * @private
         */
        this._acousticPerformance = this.singleGlazed33dB;

        /**
         * @type {Door}
         * @private
         */
        this._door = new _Door.Door(this);
        this._door.type = this._door.noDoor;

        /**
         * @type {object}
         */
        this._configuration = _Configuration.Configuration.get();

        /**
         * @type {object}
         */
        this._pricelist = _Pricelist.Pricelist.get();
    }

    /**
     * @param {string|number} width
     */


    (0, _createClass3.default)(Partition, [{
        key: 'setGlazingType',


        /**
         * @param {string} glazingType
         */
        value: function setGlazingType(glazingType) {
            if (this.hasValidDimensions === false) {
                throw new _InvalidConfigurationError.InvalidConfigurationError('Invalid Dimensions');
            }

            this._glazingType = glazingType;

            switch (glazingType) {
                case this.singleGlazingType:

                    // Need to check acoustic performance in here
                    if (this._measurementInMM(this._height) <= 2700) {

                        if (this.acousticPerformance === this.singleGlazed33dB) {
                            this._glassThickness = 1; // single glazed toughened 10mm
                        } else {
                            this._glassThickness = 4; // single glazed toughened 12mm
                        }
                    } else {

                        if (this.acousticPerformance === this.singleGlazed33dB) {
                            this._glassThickness = 2; // single glazed, acoustic laminate 10.8mm
                        } else {
                            this._glassThickness = 5; // single glazed, acoustic laminate 12.8mm
                        }
                    }

                    break;
                case this.doubleGlazingType:
                    this._glassThickness = 3; // double glazed, toughened 10mm & toughened 12mm (one sheet of each)
                    break;
                default:
                    throw new _InvalidGlazingTypeError.InvalidGlazingTypeError('Unknown Glazing Type "' + glazingType + '"');
            }
        }

        /**
         * @param {string} acousticPerformance
         */

    }, {
        key: 'setAcousticPerformance',
        value: function setAcousticPerformance(acousticPerformance) {
            this._acousticPerformance = acousticPerformance;
            // re set the glazing type to correctly set glass thickness with new acoustic performance
            this.setGlazingType(this._glazingType);
        }

        /**
         * @returns {string}
         */

    }, {
        key: '_convertToFloatNumber',


        /**
         * @param {number|string} value
         * @returns {*}
         * @private
         */
        value: function _convertToFloatNumber(value) {
            if (value === '') {
                value = 0;
            }
            if (typeof value !== 'number') {
                value = (0, _parseFloat2.default)(value);
            }
            this._isThisANumber(value);
            return value;
        }

        /**
         * @param {*} value
         * @private
         */

    }, {
        key: '_isThisANumber',
        value: function _isThisANumber(value) {
            if ((0, _isNan2.default)(value)) {
                throw new _ValueCannotBeParsedError.ValueCannotBeParsedError();
            }
        }

        /**
         * @param {number} value
         * @return {number}
         * @private
         */

    }, {
        key: '_addWastage',
        value: function _addWastage(value) {
            return 0.08 * value + value;
        }

        /**
         * @param {number} measurement
         * @private
         */

    }, {
        key: '_measurementInMM',
        value: function _measurementInMM(measurement) {
            return measurement;
        }
    }, {
        key: 'width',
        set: function set(width) {
            this._width = this._convertToFloatNumber(width);
            this._widthWithWastage = this._addWastage(this._width);
        }

        /**
         * @param {string|number} height
         */
        ,


        /**
         * @returns {number}
         */
        get: function get() {
            return this._width;
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'height',
        set: function set(height) {
            this._height = this._convertToFloatNumber(height);
            this._heightWithWastage = this._addWastage(this._height);
        }

        /**
         * @param {string|number} depth
         */
        ,


        /**
         * @returns {number}
         */
        get: function get() {
            return this._height;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'depth',
        set: function set(depth) {
            this._depth = this._convertToFloatNumber(depth);
            this._depthWithWastage = this._addWastage(this._depth);
        }

        /**
         * @param {string} type
         */
        ,
        get: function get() {
            return this._depth;
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'type',
        set: function set(type) {
            this._type = type;
        },


        /**
         * @returns {string}
         */
        get: function get() {
            return this._type;
        }
    }, {
        key: 'acousticPerformance',
        get: function get() {
            return this._acousticPerformance;
        }

        /**
         * @returns {Manifestation}
         */

    }, {
        key: 'manifestation',
        get: function get() {
            return this._manifestation;
        }

        /**
         * @returns {Door}
         */

    }, {
        key: 'door',
        get: function get() {
            return this._door;
        }
    }, {
        key: 'grandTotal',
        get: function get() {
            var totalInPence = Math.ceil(this.subTotalInPence + this.marginTotalInPence);
            var totalInPounds = totalInPence / 100;
            // console.log('totalInPounds: ' + totalInPounds);
            return totalInPounds.toFixed(2);
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'marginTotalInPence',
        get: function get() {
            var margin = this.marginPercentage / 100;
            return Math.ceil(this.subTotalInPence * margin);
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'marginPercentage',
        get: function get() {
            if (this.isDoubleGlazed) {
                switch (this.type) {
                    case this.inlineType:
                        return this._pricelist.margin.doubleGlazedInline;
                    case this.cornerType:
                        return this._pricelist.margin.doubleGlazedCorner;
                    case this.threeSidedType:
                        return this._pricelist.margin.doubleGlazedThreeSided;
                    case this.tShapeType:
                        return this._pricelist.margin.doubleGlazedTShape;
                }
            } else {
                switch (this.type) {
                    case this.inlineType:
                        return this._pricelist.margin.singleGlazedInline;
                    case this.cornerType:
                        return this._pricelist.margin.singleGlazedCorner;
                    case this.threeSidedType:
                        return this._pricelist.margin.singleGlazedThreeSided;
                    case this.tShapeType:
                        return this._pricelist.margin.singleGlazedTShape;
                }
            }
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'subTotalInPence',
        get: function get() {
            return this.tracksTotalInPence + this.gasketTotalInPence + this.abutmentTotalInPence + this.glassTotalInPence + this._door.totalInPence + this._manifestation.totalInPence + this.labourTotalInPence + this.additionalCostsInPence;
        }
    }, {
        key: 'singleGlazingType',
        get: function get() {
            return 'single';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'doubleGlazingType',
        get: function get() {
            return 'double';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'singleGlazed33dB',
        get: function get() {
            return '33dB';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'singleGlazed38dB',
        get: function get() {
            return '38dB';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'inlineType',
        get: function get() {
            return 'Inline';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'cornerType',
        get: function get() {
            return 'Corner';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'threeSidedType',
        get: function get() {
            return 'Three Sided';
        }

        /**
         * @returns {string}
         */

    }, {
        key: 'tShapeType',
        get: function get() {
            return 'T Shaped';
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'glassThickness',
        get: function get() {
            return this._glassThickness;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'numberOfTracks',
        get: function get() {
            if (this.hasValidDimensions === false) {
                return 0;
            }

            var calculation = 0;
            switch (this._type) {
                case this.inlineType:
                    calculation = this._widthWithWastage / 3.6;
                    break;
                case this.cornerType:
                case this.tShapeType:
                    calculation = this._widthWithWastage / 3.6 + this._depthWithWastage / 3.6;
                    break;
                case this.threeSidedType:
                    calculation = this._widthWithWastage / 3.6 + this._depthWithWastage / 3.6 * 2;
                    break;
            }

            if (calculation > 0) {
                return Math.ceil(calculation / 1000);
            }

            return 0;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'gasketsInMeters',
        get: function get() {
            if (this.hasValidDimensions === false) {
                return 0;
            }

            var calculation = 0;
            switch (this._type) {
                case this.inlineType:
                    calculation = this._widthWithWastage;
                    break;
                case this.cornerType:
                case this.tShapeType:
                    calculation = this._widthWithWastage + this._depthWithWastage;
                    break;
                case this.threeSidedType:
                    calculation = this._widthWithWastage + this._depthWithWastage * 2;
                    break;
            }

            return Math.ceil(calculation / 1000);
        }

        /**
         * @returns {Array}
         */

    }, {
        key: 'gasketComponents',
        get: function get() {
            var components = new Array();

            switch (this.glassThickness) {
                case 1:
                case 4:
                    components = ['singleGlazedGaskets10mmGlass'];
                    break;
                case 2:
                    components = ['singleGlazedGaskets12mmGlass'];
                    break;
                case 3:
                case 5:
                    components = ['doubleGlazedInnerGasket', 'singleGlazedGaskets10mmGlass', 'singleGlazedGaskets12mmGlass'];
                    break;
            }
            return components;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'numberOfAbutments',
        get: function get() {
            if (this.hasValidDimensions === false) {
                return 0;
            }

            switch (this._type) {
                case this.tShapeType:
                    return 3;
                default:
                    return 2;
            }
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'glassSurfaceArea',
        get: function get() {
            if (this.hasValidDimensions === false) {
                return 0;
            }

            var calculation = 0;
            switch (this._type) {
                case this.inlineType:
                    calculation = this._measurementInMM(this._widthWithWastage) * this._measurementInMM(this._heightWithWastage);
                    break;
                case this.cornerType:
                case this.tShapeType:
                    calculation = (this._measurementInMM(this._widthWithWastage) + this._measurementInMM(this._depthWithWastage)) * this._measurementInMM(this._heightWithWastage);
                    break;
                case this.threeSidedType:
                    calculation = this._measurementInMM(this._widthWithWastage) + this._measurementInMM(this._depthWithWastage) * 2;
                    calculation *= this._measurementInMM(this._heightWithWastage);
                    break;
            }

            if (calculation > 0) {

                // Calculation is now mm square so we need to move the decimal point 6 places and round up to nearest metre
                return Math.ceil(calculation / 1000000);
            }

            return calculation;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'hasValidDimensions',
        get: function get() {
            switch (this._type) {
                case this.inlineType:
                    return this._width !== 0 && this._height !== 0;
                case this.cornerType:
                case this.threeSidedType:
                case this.tShapeType:
                    return this._width !== 0 && this._height !== 0 && this._depth !== 0;
                default:
                    return true;
            }

            return false;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'additionalCostsInPence',
        get: function get() {
            return this._pricelist.additional.general + this._pricelist.additional.delivery;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'tracksTotalInPence',
        get: function get() {
            var numberOfTracks = this.numberOfTracks;
            var trackComponentsTotalInPence = 0;
            var priceList = this._pricelist;
            var components = this._configuration.singleGlazed.trackComponents;

            if (this.isDoubleGlazed === true) {
                components = this._configuration.doubleGlazed.trackComponents;
            }

            components.forEach(function (componentKey) {
                trackComponentsTotalInPence += priceList.fixings[componentKey] * numberOfTracks;
            });

            return trackComponentsTotalInPence;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'gasketTotalInPence',
        get: function get() {
            var gasketInMeters = this.gasketsInMeters;
            var gasketComponentsTotalInPence = 0;
            var components = this.gasketComponents;
            var priceList = this._pricelist;

            components.forEach(function (componentKey) {
                gasketComponentsTotalInPence += priceList.fixings[componentKey] * gasketInMeters;
            });

            return gasketComponentsTotalInPence;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'abutmentTotalInPence',
        get: function get() {
            var numberOfAbutments = this.numberOfAbutments;
            var abutmentsComponentsTotalInPence = 0;
            var priceList = this._pricelist;
            var components = this._configuration.singleGlazed.abutmentComponents;

            if (this.isDoubleGlazed === true) {
                components = this._configuration.doubleGlazed.abutmentComponents;
            }

            components.forEach(function (componentKey) {
                abutmentsComponentsTotalInPence += priceList.fixings[componentKey] * numberOfAbutments;
            });

            return abutmentsComponentsTotalInPence;
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'glassTotalInPence',
        get: function get() {
            var glassSurfaceArea = this.glassSurfaceArea;
            // console.log('glassSurfaceArea: ' + glassSurfaceArea);
            var priceList = this._pricelist;
            // console.log('priceList.glass[this.glassThickness]: ' + priceList.glass[this.glassThickness]);
            var glassTotalInPence = glassSurfaceArea * priceList.glass[this.glassThickness];

            return Math.ceil(glassTotalInPence);
        }

        /**
         * @returns {number}
         */

    }, {
        key: 'labourTotalInPence',
        get: function get() {
            return this._pricelist.labour.total;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: 'isDoubleGlazed',
        get: function get() {
            return Boolean(this.glassThickness === 3);
        }
    }]);
    return Partition;
}();

exports.Partition = Partition;

/***/ }),

/***/ "q5Zj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueCannotBeParsedError = undefined;

var _create = __webpack_require__("OvRC");

var _create2 = _interopRequireDefault(_create);

var _setPrototypeOf = __webpack_require__("kiBT");

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _from = __webpack_require__("c/Tr");

var _from2 = _interopRequireDefault(_from);

var _construct = __webpack_require__("pQ2V");

var _construct2 = _interopRequireDefault(_construct);

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = (0, _construct2.default)(cls, (0, _from2.default)(arguments));
    (0, _setPrototypeOf2.default)(instance, (0, _getPrototypeOf2.default)(this));
    return instance;
  }

  ExtendableBuiltin.prototype = (0, _create2.default)(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (_setPrototypeOf2.default) {
    (0, _setPrototypeOf2.default)(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ValueCannotBeParsedError = function (_extendableBuiltin2) {
  (0, _inherits3.default)(ValueCannotBeParsedError, _extendableBuiltin2);

  function ValueCannotBeParsedError() {
    (0, _classCallCheck3.default)(this, ValueCannotBeParsedError);
    return (0, _possibleConstructorReturn3.default)(this, (ValueCannotBeParsedError.__proto__ || (0, _getPrototypeOf2.default)(ValueCannotBeParsedError)).apply(this, arguments));
  }

  return ValueCannotBeParsedError;
}(_extendableBuiltin(Error));

exports.ValueCannotBeParsedError = ValueCannotBeParsedError;

/***/ }),

/***/ "wIMY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _Partition = __webpack_require__("pF43");

var _tinyCookie = __webpack_require__("2DS2");

var Cookies = _interopRequireWildcard(_tinyCookie);

var _mathjs = __webpack_require__("QttI");

var Math = _interopRequireWildcard(_mathjs);

var _vueCountupV = __webpack_require__("IWVV");

var _vueCountupV2 = _interopRequireDefault(_vueCountupV);

var _vueRecaptcha = __webpack_require__("olAn");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookieName = 'configurator_data'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var partition = new _Partition.Partition();

exports.default = {
    name: 'configurator',
    components: {
        ICountUp: _vueCountupV2.default,
        VueRecaptcha: _vueRecaptcha.VueRecaptcha
    },
    data: function data() {

        var phoneNumber = '';
        var configuratorTextData = {};
        var configurationDataElement = document.getElementById("configurator-text-data");
        if (configurationDataElement !== null) {
            configuratorTextData = JSON.parse(configurationDataElement.innerHTML);
            //                We need to do this so safari doesnt turn the number into a link and break json parsing
            phoneNumber = String(configuratorTextData.PhoneNumber).replace('stopsafari', '');
        }

        return {
            countupDelay: 1000,
            countupOptions: {
                useEasing: true,
                useGrouping: true,
                separator: ',',
                decimal: '.',
                prefix: '£',
                suffix: '',
                decimalPlaces: 2
            },
            configuratorVersion: '0.7.0',
            submittedForm: false,
            savedPartitions: [],
            activeClass: 'active',
            partition: new _Partition.Partition(),
            glazingType: partition.singleGlazingType,
            manifestation: 'dots',
            ironmongery: partition.door.ironmongeryDHandle,
            acousticPerformance: partition.singleGlazed33dB,
            partitionType: partition.inlineType,
            door: partition.door.singleGlazedDoorFrameless,
            width: 300,
            height: 1000,
            depth: 300,
            grandTotal: 0,
            totalOfAllPartitions: 0,
            quantity: 1,
            baseDoorImage: '/-/themes/main/client/dist/img/large-doors-base.png',
            singleGlazedDoorOptions: {
                singleGlazedDoorFrameless: {
                    name: 'Frameless Door',
                    imgPathSmall: '/-/themes/main/client/dist/img/small-doors-single.png',
                    imgPathLarge: '/-/themes/main/client/dist/img/large-doors-frameless.png'
                },
                singleGlazedDoorIncFrame: {
                    name: 'Framed Door',
                    imgPathSmall: '/-/themes/main/client/dist/img/small-doors-double.png',
                    imgPathLarge: '/-/themes/main/client/dist/img/large-doors-framed.png'
                },
                noDoor: {
                    name: 'No door',
                    imgPathSmall: '/-/themes/main/client/dist/img/small-doors-none.png',
                    imgPathLarge: '/-/themes/main/client/dist/img/large-doors-none.png'
                }
            },
            doubleGlazedDoorOptions: {
                singleGlazedDoorIncDoubleGlazedFrame: {
                    name: 'Single Glazed Framed Door',
                    imgPathSmall: '/-/themes/main/client/dist/img/small-doors-single.png',
                    imgPathLarge: '/-/themes/main/client/dist/img/large-doors-frameless.png'
                },
                doubleGlazedDoor: {
                    name: 'Double Glazed Framed Door',
                    imgPathSmall: '/-/themes/main/client/dist/img/small-doors-double.png',
                    imgPathLarge: '/-/themes/main/client/dist/img/large-doors-framed.png'
                },
                noDoor: {
                    name: 'No door',
                    imgPathSmall: '/-/themes/main/client/dist/img/small-doors-none.png',
                    imgPathLarge: '/-/themes/main/client/dist/img/large-doors-none.png'
                }
            },
            yourDetails: {
                name: "",
                email: "",
                phone: "",
                location: "",
                howDidYouHearAboutUs: "",
                promotionalConsent: false
            },
            typeOfPartitionText1: configuratorTextData.TypeOfPartitionText1,
            typeOfPartitionText2: configuratorTextData.TypeOfPartitionText2,
            dimensionsText: configuratorTextData.DimensionsText,
            glassText: configuratorTextData.GlassText,
            acousticPerformanceText: configuratorTextData.AcousticPerformanceText,
            doorText: configuratorTextData.DoorText,
            manifestationsText1: configuratorTextData.ManifestationsText1,
            manifestationsText2: configuratorTextData.ManifestationsText2,
            ironmongeryText1: configuratorTextData.IronmongeryText1,
            ironmongeryText2: configuratorTextData.IronmongeryText2,
            guideToIronmongeryLinkText: configuratorTextData.GuideToIronmongeryLinkText,
            guideToIronmongeryLink: configuratorTextData.GuideToIronmongeryLink,
            yourConfigurationText: configuratorTextData.YourConfigurationText,
            totalEstimateText: configuratorTextData.TotalEstimateText,
            phoneNumber: phoneNumber,
            contactEmail: configuratorTextData.ContactEmail,
            yourDetailsText: configuratorTextData.YourDetailsText,
            additionalProductsText: configuratorTextData.AdditionalProductsText,
            completeQuoteText: configuratorTextData.CompleteQuoteText,
            pleaseFillInYourDetailsText: configuratorTextData.PleaseFillInYourDetailsText,
            guideToPartitionsLinkText: configuratorTextData.GuideToPartitionsLinkText,
            guideToPartitionsLink: configuratorTextData.GuideToPartitionsLink,
            guideToDoorsLinkText: configuratorTextData.GuideToDoorsLinkText,
            guideToDoorsLink: configuratorTextData.GuideToDoorsLink,
            guideToManifestationsLinkText: configuratorTextData.GuideToManifestationsLinkText,
            guideToManifestationsLink: configuratorTextData.GuideToManifestationsLink,
            guideToAcousticsLinkText: configuratorTextData.GuideToAcousticsLinkText,
            guideToAcousticsLink: configuratorTextData.GuideToAcousticsLink,
            aboveSubmitText: configuratorTextData.AboveSubmitText,
            financeHeading: configuratorTextData.FinanceHeading,
            financeText: configuratorTextData.FinanceText,
            thankyouPageLink: configuratorTextData.ThankyouPageLink,
            showTotals: configuratorTextData.ShowTotals === '1',
            contactForQuoteText: configuratorTextData.ContactForQuoteText,
            submitIcon: '',
            submitQuoteText: 'Complete quote',
            acceptedTerms: false,
            promotionalConsent: false,
            showYourDetailsSection: false,
            recaptchaVerified: false
        };
    },

    watch: {
        glazingType: function glazingType(glazing) {
            if (this.isSingleGlazed === true) {
                // If the currently selected door is not allowed for single glazing types
                if (!this.singleGlazedDoorOptions.hasOwnProperty(this.door)) {
                    this.door = this.partition.door.noDoor;
                }
            }
            if (this.isDoubleGlazed === true) {
                if (!this.doubleGlazedDoorOptions.hasOwnProperty(this.door)) {
                    this.door = this.partition.door.noDoor;
                }
            }
        }
    },
    computed: {
        yourDetailsFormFilledIn: function yourDetailsFormFilledIn() {
            return Boolean(this.yourDetails.name !== '' && this.yourDetails.email !== '' && this.yourDetails.location !== '' && this.yourDetails.phone !== '' && this.yourDetails.howDidYouHearAboutUs);
        },
        widthWarning: function widthWarning() {
            return this.dimensionsErrorMessage(this.width, 'Width');
        },
        heightWarning: function heightWarning() {
            return this.dimensionsErrorMessage(this.height, 'Height');
        },
        depthWarning: function depthWarning() {
            if (this.notInlinePartition) {
                return this.dimensionsErrorMessage(this.depth, 'Depth');
            }
            return false;
        },
        dimensionsAreValid: function dimensionsAreValid() {
            return Boolean(this.widthWarning === false && this.depthWarning === false && this.heightWarning === false);
        },
        selectedDoorImage: function selectedDoorImage() {
            if (this.isSingleGlazed === true) {
                return this.singleGlazedDoorOptions[this.door].imgPathLarge;
            }
            if (this.isDoubleGlazed === true) {
                return this.doubleGlazedDoorOptions[this.door].imgPathLarge;
            }
            return this.baseDoorImage;
        },
        notInlinePartition: function notInlinePartition() {
            return Boolean(this.partitionType !== this.partition.inlineType);
        },
        isSingleGlazed: function isSingleGlazed() {
            return Boolean(this.glazingType === this.partition.singleGlazingType);
        },
        isDoubleGlazed: function isDoubleGlazed() {
            return Boolean(this.glazingType === this.partition.doubleGlazingType);
        },
        currentConfigurationTotal: function currentConfigurationTotal() {
            this.partition.type = this.partitionType;
            this.partition.width = this.width;
            this.partition.height = this.height;
            this.partition.depth = this.depth;

            var chosenManifestation = this.manifestation;
            switch (chosenManifestation) {
                case 'dots':
                case 'squares':
                    chosenManifestation = this.partition.manifestation.dotsOrSquares;
                    break;
            }

            try {
                this.partition.manifestation.type = chosenManifestation;
                this.partition.setGlazingType(this.glazingType);
                this.partition.setAcousticPerformance(this.acousticPerformance);
                this.partition.door.type = this.door;
                this.partition.door.ironmongery = this.ironmongery;
                this.grandTotal = this.partition.grandTotal;
                return this.partition.grandTotal;
            } catch (err) {
                // console.log('Error Occurred', err);
                // console.log(err);
            }
        }
    },
    methods: {
        scrollToYourDetails: function scrollToYourDetails() {
            this.showYourDetailsSection = true;
            this.$scrollTo('#your-details-anchor');
        },
        totalPriceVisibilityChanged: function totalPriceVisibilityChanged(isVisible, entry) {
            var countup = this.$children[0];
            countup.reset();
            // countup.update(this.totalOfAllPartitions);
            countup.update(this.totalOfAllPartitions);
        },
        dimensionsErrorMessage: function dimensionsErrorMessage(value, name) {

            var min = 300;
            var max = 20000;

            if (name === 'Height') {
                min = 1000;
                max = 3000;
            }

            if (value < min || value > max) {
                return min + 'mm min to ' + max + 'mm max';
            }
            return false;
        },
        dataForCookie: function dataForCookie() {
            return {
                current: {
                    partitionType: this.partitionType,
                    height: this.height,
                    depth: this.depth,
                    width: this.width,
                    manifestation: this.manifestation,
                    acousticPerformance: this.acousticPerformance,
                    ironmongery: this.ironmongery,
                    glazingType: this.glazingType,
                    door: this.door,
                    grandTotal: this.grandTotal,
                    quantity: this.quantity
                },
                yourDetails: this.yourDetails,
                savedPartitions: this.savedPartitions,
                totalOfAllPartitions: this.totalOfAllPartitions,
                configuratorVersion: this.configuratorVersion
            };
        },
        recaptchaVerify: function recaptchaVerify(response) {
            console.log('Recaptcha verified');
            this.recaptchaVerified = true;
        },
        recaptchaExpired: function recaptchaExpired(response) {
            console.log('Recaptcha expired');
            this.recaptchaVerified = false;
        },
        completeQuote: function completeQuote() {
            var _this = this;

            if (this.acceptedTerms === true && this.recaptchaVerified === true && this.submittedForm === false) {

                this.submittedForm = true;

                // To ensure the totals and cookie is up to date;
                this.updateTotalOfAllPartitions();

                var partitions = [{
                    partitionType: this.partitionType,
                    height: this.height + 'mm',
                    depth: this.depth + 'mm',
                    width: this.width + 'mm',
                    manifestation: this.manifestationString(this.manifestation),
                    glazingType: this.glazingTypeString(this.glazingType, this.acousticPerformance),
                    door: this.doorString(this.door, this.ironmongery),
                    grandTotal: '£' + this.grandTotal,
                    quantity: this.quantity
                }];

                if (this.savedPartitions !== undefined) {
                    for (var i = 0; i < this.savedPartitions.length; i++) {
                        var _partition = this.savedPartitions[i];
                        partitions.push({
                            partitionType: _partition.partitionType,
                            height: _partition.height + 'mm',
                            depth: _partition.depth + 'mm',
                            width: _partition.width + 'mm',
                            manifestation: this.manifestationString(_partition.manifestation),
                            glazingType: this.glazingTypeString(_partition.glazingType, _partition.acousticPerformance),
                            door: this.doorString(_partition.door, _partition.ironmongery),
                            grandTotal: '£' + _partition.grandTotal,
                            quantity: _partition.quantity
                        });
                    }
                }

                var yourDetails = this.yourDetails;
                var totalOfAllPartitions = '£' + this.totalOfAllPartitions;

                var body = {
                    partitions: (0, _stringify2.default)(partitions),
                    yourDetails: (0, _stringify2.default)(yourDetails),
                    totalOfAllPartitions: (0, _stringify2.default)(totalOfAllPartitions)
                };

                this.$http.post(window.location.href + '/send', body).then(function (response) {
                    if (response.status === 200) {
                        _this.submitQuoteText = 'Quote submitted';
                        _this.submitIcon = '<i class="fas fa-check" aria-hidden="true"></i>';
                        window.location.href = _this.thankyouPageLink;
                    }
                }, function (response) {
                    _this.submitQuoteText = 'Quote not submitted';
                    _this.submitIcon = '<i class="fas fa-times" aria-hidden="true"></i>';
                    alert('Your submission could not be completed, please try again later.');
                    _this.submittedForm = false;
                });
            }
        },
        updateTotalOfAllPartitions: function updateTotalOfAllPartitions() {
            var total = this.currentConfigurationTotal * this.quantity;
            if (this.savedPartitions !== undefined) {
                for (var i = 0; i < this.savedPartitions.length; i++) {
                    total += Number(this.savedPartitions[i].grandTotal) * Number(this.savedPartitions[i].quantity);
                }
            }
            this.totalOfAllPartitions = Math.round(total, 2);
            this.forceUpdate();
            Cookies.set(cookieName, (0, _stringify2.default)(this.dataForCookie()), 1);
        },
        forceUpdate: function forceUpdate() {
            this.$forceUpdate();
        },
        savePartition: function savePartition() {
            var partitionData = {
                "partitionType": this.partitionType,
                "height": this.height,
                "depth": this.depth,
                "width": this.width,
                "manifestation": this.manifestation,
                "glazingType": this.glazingType,
                "acousticPerformance": this.acousticPerformance,
                "ironmongery": this.ironmongery,
                "door": this.door,
                "grandTotal": this.currentConfigurationTotal,
                "quantity": this.quantity
            };
            // Add the current partition to the array
            this.savedPartitions.unshift(partitionData);

            // Reset the configurator values to their original values
            this.glazingType = this.partition.singleGlazingType;
            this.manifestation = 'dots';
            this.partitionType = this.partition.inlineType;
            this.acousticPerformance = this.partition.singleGlazed33dB;
            this.ironmongery = this.partition.door.ironmongeryDHandle;
            this.door = this.partition.door.singleGlazedDoorFrameless;
            this.width = 1000;
            this.height = 1000;
            this.depth = 1000;
            this.quantity = 1;
            this.updateTotalOfAllPartitions();
            this.$scrollTo('#type-of-partition-section-anchor');
        },
        removeSavedPartition: function removeSavedPartition(index) {
            this.savedPartitions.splice(index, 1);
            this.updateTotalOfAllPartitions();
        },
        partitionTypeImgPath: function partitionTypeImgPath(string) {
            if (string === undefined) {
                string = this.partitionType;
            }
            switch (string) {
                case this.partition.inlineType:
                    return '/-/themes/main/client/dist/img/inline-glass-box.png';
                    break;
                case this.partition.cornerType:
                    return '/-/themes/main/client/dist/img/corner-glass-box.png';
                    break;
                case this.partition.threeSidedType:
                    return '/-/themes/main/client/dist/img/three-sided-glass-box.png';
                    break;
                case this.partition.tShapeType:
                    return '/-/themes/main/client/dist/img/t-glass-box.png';
                    break;
                default:
                    return '';
                    break;
            }
        },
        glazingTypeString: function glazingTypeString(glazingType, acousticPerformance) {
            if (glazingType === undefined) {
                glazingType = this.glazingType;
            }
            if (acousticPerformance === undefined) {
                acousticPerformance = this.acousticPerformance;
            }

            var acousticPerformanceString = '';

            switch (acousticPerformance) {
                case this.partition.singleGlazed33dB:
                    acousticPerformanceString = '(33dB)';
                    break;
                case this.partition.singleGlazed38dB:
                    acousticPerformanceString = '(38dB)';
                    break;
                default:
                    return '';
                    break;
            }

            switch (glazingType) {
                case this.partition.singleGlazingType:
                    return 'Single Glazed ' + acousticPerformanceString;
                    break;
                case this.partition.doubleGlazingType:
                    return 'Double Glazed';
                    break;
                default:
                    return '';
                    break;
            }
        },
        glazingTypeImgPath: function glazingTypeImgPath(string) {
            if (string === undefined) {
                string = this.glazingType;
            }
            switch (string) {
                case 'single':
                    return '/-/themes/main/client/dist/img/glass-single.png';
                    break;
                case 'double':
                    return '/-/themes/main/client/dist/img/glass-double.png';
                    break;
                default:
                    return '';
                    break;
            }
        },
        doorImgPath: function doorImgPath(string) {
            if (string === undefined) {
                string = this.door;
            }
            switch (string) {
                case 'noDoor':
                    return '/-/themes/main/client/dist/img/small-doors-none.png';
                    break;
                case 'singleGlazedDoorFrameless':
                case 'singleGlazedDoorIncDoubleGlazedFrame':
                    return '/-/themes/main/client/dist/img/small-doors-single.png';
                    break;
                case 'singleGlazedDoorIncFrame':
                case 'doubleGlazedDoor':
                    return '/-/themes/main/client/dist/img/small-doors-double.png';
                    break;
                default:
                    return '';
                    break;
            }
        },
        doorString: function doorString(door, ironmongery) {

            if (door === undefined) {
                door = this.door;
            }

            if (ironmongery === undefined) {
                ironmongery = this.ironmongery;
            }

            var ironmongeryString = '';

            switch (ironmongery) {
                case this.partition.door.ironmongeryDHandle:
                    ironmongeryString = '(D Handle)';
                    break;
                case this.partition.door.ironmongeryManet:
                    ironmongeryString = '(Manet Handle)';
                    break;
                case this.partition.door.ironmongeryLeverLock:
                    ironmongeryString = '(Lever Lock Handle)';
                    break;
                default:
                    return '';
                    break;
            }

            switch (door) {
                case 'noDoor':
                    return 'No Door';
                    break;
                case 'singleGlazedDoorFrameless':
                    return 'Frameless Door ' + ironmongeryString;
                    break;
                case 'singleGlazedDoorIncDoubleGlazedFrame':
                case 'singleGlazedDoorIncFrame':
                    return 'Single Glazed Framed Door ' + ironmongeryString;
                    break;
                case 'doubleGlazedDoor':
                    return 'Double Glazed Framed Door ' + ironmongeryString;
                    break;
                default:
                    return '';
                    break;
            }
        },
        manifestationImgPath: function manifestationImgPath(string) {
            if (string === undefined) {
                string = this.manifestation;
            }
            switch (string) {
                case 'dots':
                    return '/-/themes/main/client/dist/img/manifestations-dots.png';
                    break;
                case 'squares':
                    return '/-/themes/main/client/dist/img/manifestations-squares.png';
                    break;
                case 'opalFrostBand':
                    return '/-/themes/main/client/dist/img/manifestations-opal-band.png';
                    break;
                case 'opalFrostFull':
                    return '/-/themes/main/client/dist/img/manifestations-opal-full.png';
                    break;
                default:
                    return '';
                    break;
            }
        },
        manifestationString: function manifestationString(string) {
            if (string === undefined) {
                string = this.manifestation;
            }
            switch (string) {
                case 'dots':
                    return 'Dots';
                    break;
                case 'squares':
                    return 'Squares';
                    break;
                case 'opalFrostBand':
                    return 'Opal Frost Band';
                    break;
                case 'opalFrostFull':
                    return 'Opal Frost Full Cover';
                    break;
                default:
                    return '';
                    break;
            }
        },
        setPartitionType: function setPartitionType(type) {
            this.partitionType = type;
            this.updateTotalOfAllPartitions();
        },
        setGlazingType: function setGlazingType(type) {
            // don't need to do this unless they are changing type
            if (this.glazingType !== type) {
                // if the door is set to anything other than no door
                if (this.door !== this.partition.door.noDoor) {
                    switch (type) {
                        case this.partition.singleGlazingType:
                            this.door = this.partition.door.singleGlazedDoorFrameless;
                            break;
                        case this.partition.doubleGlazingType:
                            this.door = this.partition.door.singleGlazedDoorIncDoubleGlazedFrame;
                            break;
                        default:
                    }
                }
            }
            this.glazingType = type;

            this.updateTotalOfAllPartitions();
        },
        setAcousticPerformance: function setAcousticPerformance(type) {
            this.acousticPerformance = type;
            this.updateTotalOfAllPartitions();
        },
        setManifestation: function setManifestation(type) {
            this.manifestation = type;
            this.updateTotalOfAllPartitions();
        },
        setIronmongery: function setIronmongery(type) {
            this.ironmongery = type;
            this.updateTotalOfAllPartitions();
        },
        setDoor: function setDoor(type, imgPathLarge) {
            this.door = type;
            if (imgPathLarge !== undefined) {
                this.selectedDoorImage = imgPathLarge;
            }
            this.updateTotalOfAllPartitions();
        },
        downloadConfig: function downloadConfig() {
            var object = {
                "partitionType": this.partitionType,
                "height": this.height,
                "depth": this.depth,
                "width": this.width,
                "manifestation": this.manifestation,
                "ironmongery": this.ironmongery,
                "acousticPerformance": this.acousticPerformance,
                "glazingType": this.glazingType,
                "door": this.door,
                "debugInfo": {
                    "calculatedWidth": this.partition.calculatedWidth,
                    "calculatedHeight": this.partition.calculatedHeight,
                    "calculatedDepth": this.partition.calculatedDepth,
                    "gasketComponents": this.partition.gasketComponents,
                    "numberOfTracks": this.partition.numberOfTracks,
                    "gasketsInMeters": this.partition.gasketsInMeters,
                    "glassSurfaceArea": this.partition.glassSurfaceArea,
                    "marginPercentage": this.partition.marginPercentage,
                    "numberOfAbutments": this.partition.numberOfAbutments
                },
                "componentPriceTotals": {
                    "gasketTotal": this.partition.gasketTotalInPence,
                    "abutmentTotal": this.partition.abutmentTotalInPence,
                    "manifestationTotal": this.partition.manifestation.totalInPence,
                    "tracksTotal": this.partition.tracksTotalInPence,
                    "glassTotal": this.partition.glassTotalInPence,
                    "doorTotal": this.partition.door.totalInPence,
                    "labourTotal": this.partition.labourTotalInPence,
                    "additionalCosts": this.partition.additionalCostsInPence
                },
                "subTotal": this.partition.subTotalInPence,
                "marginPercentage": this.partition.marginPercentage,
                "marginTotal": this.partition.marginTotalInPence,
                "grandTotal": this.grandTotal
            };

            var debugContentString = (0, _stringify2.default)(object, null, '\t');
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(debugContentString));
            element.setAttribute('download', 'configuratorDebug.json');
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
        }
    },
    mounted: function mounted() {
        this.$nextTick(function () {

            var data = undefined;
            if (cookieName !== undefined) {
                if (Cookies.get(cookieName) !== null) {

                    data = JSON.parse(Cookies.get(cookieName));

                    if (data.configuratorVersion === this.configuratorVersion) {
                        this.partitionType = data.current.partitionType;
                        this.height = data.current.height;
                        this.depth = data.current.depth;
                        this.width = data.current.width;
                        this.manifestation = data.current.manifestation;
                        this.glazingType = data.current.glazingType;
                        this.acousticPerformance = data.current.acousticPerformance;
                        this.ironmongery = data.current.ironmongery;
                        this.door = data.current.door;
                        this.grandTotal = data.current.grandTotal;
                        this.quantity = data.current.quantity;
                        this.yourDetails = data.yourDetails;
                        this.savedPartitions = data.savedPartitions;
                        this.totalOfAllPartitions = data.totalOfAllPartitions;
                    } else {
                        Cookies.remove(cookieName);
                    }
                }
            }
            this.updateTotalOfAllPartitions();
        });
    }
};

/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Configurator = __webpack_require__("aQ+T");

var _Configurator2 = _interopRequireDefault(_Configurator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'app',
    components: {
        Configurator: _Configurator2.default
    }
}; //
//
//
//
//
//

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.js